import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap, timeout } from 'rxjs/operators';

@Injectable({providedIn:'root'})
export class RequestServiceBase {
  // base URI from environment
  protected baseUrl = environment.baseURL;
  // endpoints
  protected readonly wagonEndpoint: string = 'wagon';
  protected readonly trainEndpoint: string = 'train';
  protected readonly userEndpoint: string = 'user';
  protected readonly evaluationEndpoint: string = 'evaluation';
  protected readonly variantEndpoint: string = 'variant';
  protected readonly masterdataEndpoint: string = 'masterdata';
  protected readonly projectEndpoint: string = 'project';
  protected readonly companyEndpoint: string = 'company';
  protected readonly passengerBehaviourEndpoint: string = 'passengerbehaviourdata';
  // actions
  protected readonly writeAction: string = 'Write';
  protected readonly deleteAction: string = 'Delete';
  // seperator
  protected readonly routeSeperator: string = '/';

  public constructor(protected httpClient: HttpClient) {
  }
  private getTimeoutInterval() {
    var date = new Date();
    date.setMinutes(date.getMinutes() + 10);
    return date;
  }
  public getOne<T>(action: string, param: any, endpoint: string): Observable<T> {
    return this.httpClient.get<T>(`${this.baseUrl}/${endpoint}/${param}`)
      .pipe(
        timeout(this.getTimeoutInterval()),
        tap(
          data => {
          },
          error => {
            catchError(this.handleError(`Service call to ${action} failed.`, []));
          }
        )
      );
  }

  public getAll<T>(action: string, param: any, endpoint: string): Observable<T[]> {
    return this.httpClient.get<T[]>(`${this.baseUrl}/${endpoint}/${param}`)
      .pipe(
        timeout(this.getTimeoutInterval()),
        tap(
          data => {
          },
          error => {
            catchError(this.handleError(`Service call to ${action} failed.`, []));
          }
        )
      );
  }

  public post<T>(action: string, item: any, endpoint: string) {
    return this.httpClient.post<T>(`${this.baseUrl}/${endpoint}/${action}`, item)
      .pipe(
        timeout(this.getTimeoutInterval()),
        tap(
          data => {
          },
          error => {
            catchError(this.handleError(`Service call to ${action} failed.`, []));
          }
        )
      );
  }

  public blobResponse(action: string, item: any, endpoint: string) {
    return this.httpClient.post(`${this.baseUrl}/${this.evaluationEndpoint}/${action}`, item, { responseType: 'blob', observe: "response" })
      .pipe(
        timeout(this.getTimeoutInterval()),
        tap(
          data => {
          },
          error => {
            catchError(this.handleError(`Service call to ${action} failed.`, []));
          }
        )
      );
  }

  public update<T>(action: string, item: T, endpoint: string): Observable<T> {
    return this.httpClient.put<T>(`${this.baseUrl}/${endpoint}/${action}`, item)
      .pipe(
        timeout(this.getTimeoutInterval()),
        tap(
          data => {
          },
          error => {
            catchError(this.handleError(`Service call to ${action} failed.`, []));
          }
        )
      );
  }

  public delete<T>(action: string, param: any, endpoint: string) {
    return this.httpClient.delete(`${this.baseUrl}/${endpoint}/${param}`)
      .pipe(
        timeout(this.getTimeoutInterval()),
        tap(
          data => {
          },
          error => {
            catchError(this.handleError(`Service call to ${action} failed.`, []));
          }
        )
      );
  }

  // Google proposal of handling errors with the new HttpClient
  public handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}